/* eslint-disable max-len */
import React from 'react';

import Icon from '@mui/icons-material/Login';

const LoginIcon = (props) => <Icon {...props} />;

export default LoginIcon;
